import {Box, HStack, VStack} from '@chakra-ui/react';
import {ItemCatalogue2StateFF} from 'ff-common';
import {State} from '@synako/halitrek';
import {ModeTarifaireSouhaite, NatureDuPrix} from 'api-types/ffconnect';
import {CategorieDeTarif} from 'api-types/tolede';
import {LigneDePanierDesc} from 'api-types/ffconnect-hal';
import {PrixBlockUnitaire} from '@/domains/cadencier/components/PrixBlockUnitaire';
import {AjouterAvecPrixSaisi} from '@/hooks/panier/useAjouterAvecPrixSaisi';

export const ProduitBottomBar: React.FC<{
  itemState: ItemCatalogue2StateFF;
  prixHT: number;
  prixTtc?: number;
  tva: number;
  buyBlock: React.ReactElement | undefined;
  ligneDePanier?: State<LigneDePanierDesc>;
  typePrix?: NatureDuPrix;
  categorieDeTarif?: CategorieDeTarif;
  modeTarifaireSouhaite?: ModeTarifaireSouhaite;
  saisieAvantAjout?: boolean;
  ajouterAvecPrixSaisi?: AjouterAvecPrixSaisi;
  codeArticle?: string;
}> = ({
  itemState,
  prixHT,
  prixTtc,
  tva,
  buyBlock,
  ligneDePanier,
  typePrix,
  categorieDeTarif,
  modeTarifaireSouhaite,
  saisieAvantAjout,
  ajouterAvecPrixSaisi,
  codeArticle,
}) => {
  const uniteFacturation = itemState.data.unite_de_facturation;

  return (
    <>
      <Box
        position='fixed'
        bottom='4.5rem'
        left={0}
        right={0}
        zIndex='dropdown'
        bg='white'
        p='10px'
        borderTopWidth='1px'
        borderColor='gray.light'
        shadow='md'
      >
        <HStack p='0px 15px 0px 10px'>
          <VStack
            width='30%'
            alignItems='flex-start'
            gap='0'
            flex='2'
          >
            <PrixBlockUnitaire
              prixUnitaire={prixHT}
              prixUnitaireTtc={prixTtc}
              uniteFacturation={uniteFacturation}
              tauxTVA={tva}
              style={{mt: 0}}
              ligneDePanier={ligneDePanier}
              typePrix={typePrix}
              categorieDeTarif={categorieDeTarif}
              modeTarifaireSouhaite={modeTarifaireSouhaite}
              saisieAvantAjout={saisieAvantAjout}
              ajouterAvecPrixSaisi={ajouterAvecPrixSaisi}
              codeArticle={codeArticle}
            />
          </VStack>
          <Box width='62%'>{buyBlock}</Box>
        </HStack>
      </Box>
    </>
  );
};
